
import axiosInstance from "../../../../api/AxiosInstance";
import { endpoints } from "../../../../services/endpoints";
import { getSupplierProductsRequest, getSupplierProductsRequestError, getSupplierProductsRequestSuccess } from "../../../slices/User/Detail/GetSupplierProductSlice";

export const GetSupplierProductsApi = (search, category, productType, supplierId, page, limit) => async (dispatch) => {
    const queryParams = new URLSearchParams({
        page: page,
        category: category,
        productType: productType,
        supplierId: supplierId,
        search: search,
        limit: limit
    }).toString();

    const urlWithParams = `${endpoints.getSupplierProducts}?${queryParams}`;

    try {
        dispatch(getSupplierProductsRequest());
        axiosInstance({
            method: "GET",
            url: urlWithParams,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getSupplierProductsRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getSupplierProductsRequestError(_error));
            });
    } catch (error) {
    }
};
